/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkPrintRequest } from '../../models/bulk-print-request';

export interface ListBulkPrintRequests$Params {
  programId: string;
}

export function listBulkPrintRequests(
  http: HttpClient,
  rootUrl: string,
  params: ListBulkPrintRequests$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<BulkPrintRequest>>> {
  const rb = new RequestBuilder(rootUrl, listBulkPrintRequests.PATH, 'get');
  if (params) {
    rb.path('programId', params.programId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BulkPrintRequest>>;
    })
  );
}

listBulkPrintRequests.PATH = '/bulk-print/program/{programId}';
